import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppStatus } from '@/features/admin-email/queries';

/**
 * Banner shown to every authenticated user when Email Test Mode is
 * on. Polls /app-status every minute (handled by useAppStatus) so a
 * superadmin who flips the toggle in another tab sees the banner
 * appear / disappear without a hard refresh.
 *
 * Hidden silently when the query is loading or errors out — we
 * never want the banner to lie about a config we can't read.
 */
export function EmailTestModeBanner() {
  const { t } = useTranslation();
  const { data } = useAppStatus();
  if (!data?.emailTestMode.enabled) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="email-test-mode-banner"
      className="flex items-center gap-2 border-b border-violet-300 bg-violet-100 px-4 py-2 text-sm text-violet-900"
    >
      <AlertTriangle aria-hidden className="h-4 w-4 shrink-0" />
      <p>{t('adminEmail.banner.message')}</p>
    </div>
  );
}
